import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const MentionsLegales = () => {
  const { t } = useTranslation();
  
  // Mise à jour du titre de la page
  useEffect(() => {
    document.title = "SOCABEG - Société d'Aménagement de Bâtiment et d'Etudes Générales";
  }, []);

  return (
    <div>
      <div className="container mx-auto px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white rounded-lg shadow-md p-6 mb-8">
          <h2 className="text-2xl font-bold text-socabeg-blue mb-6">{t('legal.title')}</h2>
          
          <div className="space-y-6">
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('legal.editor.title')}</h3>
              <p className="mb-2"><strong>{t('legal.editor.company')}:</strong> SOCABEG (Société d'Aménagement de Bâtiment et d'Etudes Générales)</p>
              <p className="mb-2"><strong>{t('legal.editor.legalForm')}:</strong> Société Anonyme</p>
              <p className="mb-2"><strong>{t('legal.editor.address')}:</strong> Fann-Hock – Corniche face Cour Suprême, BP 1270, Dakar, Sénégal</p>
              <p className="mb-2"><strong>{t('legal.editor.phone')}:</strong> +221 33 889 35 35 / +221 33 889 30 99 / +221 70 825 55 22</p>
              <p className="mb-2"><strong>{t('legal.editor.email')}:</strong> infos@socabeg.com</p>
            
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('legal.publication.title')}</h3>
              <p className="mb-2"><strong>{t('legal.publication.responsible')}:</strong> SOCABEG</p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('legal.development.title')}</h3>
              <p className="mb-2">{t('legal.development.text')} <strong>OWL TECHNOLOGY</strong></p>
              <p className="mb-2"><strong>GitHub:</strong> <a href="https://github.com/taphacoobams" target="_blank" rel="noopener noreferrer" className="text-socabeg-blue hover:underline">https://github.com/taphacoobams</a></p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('legal.hosting.title')}</h3>
              <p className="mb-2">{t('legal.hosting.text')}</p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('legal.intellectual.title')}</h3>
              <p className="mb-4">{t('legal.intellectual.text1')}</p>
              <p className="mb-4">{t('legal.intellectual.text2')}</p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('legal.liability.title')}</h3>
              <p className="mb-4">{t('legal.liability.text1')}</p>
              <p className="mb-4">{t('legal.liability.text2')}</p>
              <ul className="list-disc pl-6 mb-4 space-y-2">
                <li>{t('legal.liability.point1')}</li>
                <li>{t('legal.liability.point2')}</li>
                <li>{t('legal.liability.point3')}</li>
              </ul>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('legal.links.title')}</h3>
              <p className="mb-4">{t('legal.links.text')}</p>
            </section>
            
            <section>
              <h3 className="text-xl font-semibold mb-3">{t('legal.applicable.title')}</h3>
              <p className="mb-4">{t('legal.applicable.text')}</p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MentionsLegales;
